var _circle, _path, _path2, _path3, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.902 16.52 1.757 4.862s.22.455.454.455c.236 0 3.733-3.639 3.733-3.639l3.89-7.513-9.771 4.58-.063 1.255z",
    fill: "#C8DAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.23 17.767-.336 3.584s-.142 1.098.956 0c1.098-1.098 2.15-1.945 2.15-1.945",
    fill: "#A9C6D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.933 16.694 8.32 15.516s-.431-.175-.293-.572c.029-.082.087-.152.26-.272.8-.558 14.819-5.597 14.819-5.597s.396-.133.63-.045c.107.04.175.087.232.254.021.06.034.19.032.319-.001.093-.013.179-.021.314-.085 1.377-2.64 11.659-2.64 11.659s-.153.602-.7.622c-.2.008-.443-.033-.733-.282-1.074-.925-4.79-3.422-5.61-3.97-.047-.031-.06-.072-.068-.11-.011-.059.05-.13.05-.13s6.47-5.75 6.641-6.354c.014-.047-.036-.07-.104-.05-.43.158-7.878 4.861-8.7 5.38-.048.031-.183.012-.183.012",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.f98cfbff.svg";
export { ForwardRef as ReactComponent };